const forms = [
    {
        'action': "form_contact",
        'id' : "form_contact"
    }
];


const initRecaptcha = () => {
    for(let form of forms){
        $('#'+form.id).submit(function(e) {
            if($(this).find("div.submit_recaptcha").length > 0){
                // we stoped it
                e.preventDefault();
                // needs for recaptacha ready
                grecaptcha.ready(function () {
                    // do request for recaptcha token
                    // response is promise with passed token
                    grecaptcha.execute(G_recaptcha, {action: form.action}).then(function (token) {
                        // add token to form
                        $('#'+form.id).prepend('<input type="hidden" name="token" value="' + token + '">');
                        $('#'+form.id).prepend('<input type="hidden" name="action" value="'+form.action+'">');
                        // submit form now
                        $('#'+form.id).unbind('submit').submit();
                    });
                });
            }
        });
    }

    tarteaucitron.services.recaptcha_v3 = {
        "key": "recaptcha_v3",
        "type": "api",
        "name": "Google Recaptcha V3",
        "needConsent": true,
        "cookies": [],
        "readmoreLink": "https://policies.google.com/privacy",
        "js": function () {
            "use strict";
            tarteaucitron.fallback(['recaptcha_v3'], function (x) {
                return '<div class="submit_recaptcha"></div>';
            });
        },
        "fallback": function () {
            "use strict";
            var id = 'recaptcha_v3';
            tarteaucitron.fallback(['recaptcha_v3'], function (elem) {
                return tarteaucitron.engage(id);
            });
        }
    }
    ;

    (tarteaucitron.job = tarteaucitron.job || []).push('recaptcha_v3');

}

export default initRecaptcha;


// WEBPACK FOOTER //
// ./src/js/app/forms.js